<template>
<div class="modal is-large is-active">
    <div class="modal-background"></div>
    <div class="modal-content">
        <div class="custom-modal-box">
            <div class="default-settings-title">
                <span class="account-name">Database restore history</span>
                <span class="default-settings-subtitle">Restore history of the database <strong>{{ database.name }}</strong>.</span>
            </div>

            <div class="backup" style="margin-bottom: 35px;">
                <div class="columns is-multiline">
                    <!-- <div class="column is-full" style="margin-top:-10px;">
                        <div class="notification is-default" style="font-size:13px;">
                            The restore history of this database is empty.
                        </div>
                    </div> -->
                    <div class="column is-full">
                        <table v-if="!loadingRestores && restoresLoadedOnce" class="custom-table">
                            <thead>
                                <th>Status</th>
                                <th>Source backup</th>
                                <th>Duration</th>
                            </thead>
                            <tbody>
                                <tr v-if="!hasRestores">
                                    <th>There is no restore history to be displayed for this database.</th>
                                </tr>
                                <tr v-for="restore in restores.data" v-bind:key="restore.id">
                                    <th>
                                        <span class="tag"
                                            style="min-width:90px;"
                                            :class="{ 'is-success': statusIs('completed', restore), 'is-info': statusIs('in_progress', restore), 'is-danger': statusIs('errored', restore) }"
                                        >{{ statusLabel(restore) }}
                                        </span>
                                    </th>
                                    <th>
                                        <span class="column-text">{{ restore.sourceable.file_name }}</span>
                                    </th>
                                    <th><span class="column-text">{{ restore.duration_in_minutes ? restore.duration_in_minutes : '-' }}</span></th>
                                </tr>
                            </tbody>
                        </table>
                        <div v-if="hasRestores && !loadingRestores && hasMoreThanOnePage" class="columns is-multiline">
                            <div class="column is-full p-bottom-0">
                                <p class="pagination-details">Showing page <span>{{ restores.meta.current_page }}</span> of <span>{{ restores.meta.last_page }}</span></p>
                            </div>
                            <div class="column is-1 is-offset-5 p-top-0 has-text-right">
                                <div @click="paginatePrevPage" :class="{ 'cursor-not-allowed': !prevPageAvailable}" class="button is-default-custom">
                                    <font-awesome-icon icon="angle-left"/>
                                </div>
                            </div>
                            <div class="column is-1 p-top-0">
                                <div @click="paginateNextPage" :class="{ 'cursor-not-allowed': !nextPageAvailable}" class="button is-default-custom">
                                    <font-awesome-icon icon="angle-right"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- <div class="columns is-multiline" style="margin-top: 10px;"> -->
                <!-- <div class="column is-3">
                    <div @click="changeEncryption" :disabled="saveButtonDisabled" :class="{ 'is-loading': changingEncryptionKey }" class="button custom-button-size is-fullwidth is-info">{{ saveButtonText }}</div>
                </div> -->
                <!-- <div class="column is-3">
                    <div @click="close" class="close-add-monitor-modal button custom-button-size is-fullwidth is-danger">Close</div>
                </div> -->
            <!-- </div> -->
        </div>
    </div>
    <button @click="close" class="modal-close is-large" aria-label="close"></button>
</div>
</template>

<script>
import Api from '@/api';
import Swal from 'sweetalert2';

export default {
    props: ['database'],

    data() {
        return {
            restores: [],
            loadingRestores: false,
            restoresLoadedOnce: false,
            page: 1,
        }
    },

    mounted() {
        this.getRestores();
        this.listenEvents();
    },

    methods: {
        close() {
            Event.$emit('restoreHistoryModalClosed');
        },

        getRestores() {
            if (this.loadingRestores) {
                return;
            }

            this.loadingRestores = false;

            Api().get('databases/' + this.database.id + '/restores?page=' + this.page)
                .then((success) => {
                    this.restores = success.data;
                })
                .finally(() => {
                    this.loadingRestores = false;
                    this.restoresLoadedOnce = true;
                });
        },

        paginatePrevPage() {

        },

        paginateNextPage() {

        },

        listenEvents() {
            //
        },

        statusIs(status, restore) {
            return status === restore.status;
        },

        statusLabel(restore) {
            if (this.statusIs('completed', restore)) {
                return 'Completed';
            }
            if (this.statusIs('pending', restore)) {
                return 'Pending';
            }
            if (this.statusIs('in_progress', restore)) {
                return 'In progress';
            }
            if (this.statusIs('errored', restore)) {
                return 'Failed';
            }
        },
    },

    computed: {
        hasRestores() {
            if (typeof this.restores.data === 'undefined') {
                return false;
            }

            return this.restores.data.length > 0;
        },

        hasMoreThanOnePage() {
            if (!this.hasRestores) {
                return false;
            }

            if (typeof this.restores.meta === 'undefined') {
                return false;
            }

            return this.restores.meta.last_page > 1;
        },

        prevPageAvailable() {
            if (typeof this.restores.meta === 'undefined') {
                return false;
            }

            return this.restores.meta.current_page > 1 && !this.loadingRestores;
        },

        nextPageAvailable() {
            if (typeof this.restores.meta === 'undefined') {
                return false;
            }

            return this.restores.meta.current_page < this.restores.meta.last_page && !this.loadingRestores;
        },
    },
}
</script>
